import { darken } from '@mui/material';

import { COLORS } from './tokens/colors';

export function getStripedBackgroundCSS(baseColor: string, gapWidthPx = 12) {
  const stripeWidthPx = gapWidthPx / 2;
  return `repeating-linear-gradient(
            45deg,
            ${baseColor}, /* Color of the stripe */
            ${baseColor} ${stripeWidthPx}px, /* Width of the stripe */
            ${darken(baseColor, 0.25)} ${stripeWidthPx}px, /* Color of the gap */
            ${darken(baseColor, 0.2)} ${gapWidthPx}px /* Width of the gap */
        )`;
}

/**
 * Returns a navy gradient background image commonly used for illustration containers
 */
export function getNavyGradientBackground() {
  return `linear-gradient(to bottom, ${COLORS.NAVY[800]}, ${COLORS.NAVY[900]})`;
}
